export default __webpack_public_path__ + "static/media/host.339756a1.png";